import { esClaveComun, tieneSecuencia } from '../../worker/passwordComunes.ts';

export const LARGO_MINIMO_CLAVE = 10;

/**
 * Puntaje 0-4 con una heurística chica (sin librerías): premia el largo y la
 * variedad, castiga secuencias, repeticiones y claves comunes. El veredicto
 * final (incluida la consulta a Have I Been Pwned) lo da el Worker.
 */
export function puntuarClave(password: string): number {
  if (!password) return 0;
  if (esClaveComun(password)) return 0;
  let puntos = 0;
  if (password.length >= LARGO_MINIMO_CLAVE) puntos += 1;
  if (password.length >= 14) puntos += 1;
  if (password.length >= 18) puntos += 1;
  const clases = [/[a-záéíóúñ]/i, /[A-ZÁÉÍÓÚÑ]/, /\d/, /[^\p{L}\d]/u].filter((r) => r.test(password)).length;
  if (clases >= 3) puntos += 1;
  if (tieneSecuencia(password)) puntos -= 1;
  return Math.max(0, Math.min(4, puntos));
}

const ETIQUETAS = ['Muy débil', 'Débil', 'Regular', 'Buena', 'Muy buena'];
const COLORES = ['bg-estado-error', 'bg-estado-error', 'bg-primario-400', 'bg-verde-400', 'bg-verde-400'];

/** Barra de 4 segmentos + texto. Mostrar debajo del campo de contraseña nueva. */
export function MedidorClave({ password }: { password: string }) {
  if (!password) return null;
  const p = puntuarClave(password);
  const faltan = LARGO_MINIMO_CLAVE - password.length;
  return (
    <div className="mt-1.5" aria-live="polite">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <span
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors ${i <= p ? COLORES[p] : 'bg-contorno-var'}`}
          />
        ))}
      </div>
      <p className="mt-1 text-xs text-neutro-500">
        {faltan > 0
          ? `Faltan ${faltan} caracteres (mínimo ${LARGO_MINIMO_CLAVE})`
          : `${ETIQUETAS[p]}${p <= 1 ? ' — probá una frase larga que solo vos recuerdes' : ''}`}
      </p>
    </div>
  );
}
